
























































































































































































import Vue from 'vue';
import CritterList from '@/components/CritterList.vue';
import { Critter } from '@/shared/models/critter';
import { CritterTypeObj } from '@/shared/models/critterTypeObj';
import CritterBasicSelect from '@/components/CritterBasicSelect.vue';
import CritterModal from '@/components/CritterModal.vue';
import CritterInfo from '@/components/CritterInfo.vue';
import showCritterInfo from '@/shared/useShowCritterInfo';
import { mapActions, mapMutations, mapState } from 'vuex';

export default Vue.extend({
  setup() {
    const { isModalVisible, currentCritter, toggleCritterInfo } = showCritterInfo();
    return {
      isModalVisible,
      currentCritter,
      toggleCritterInfo,
    };
  },
  components: { CritterList, CritterBasicSelect, CritterModal, CritterInfo },
  data() {
    return {
      timeRange: [1, 24],
      ticksLabels: [...Array(24).keys()].map(num => {
        num += 1;
        return num % 2 ? num : '';
      }),
      critterSearch: {
        lang: {
          text: this.$store.state.lang.text,
          value: this.$store.state.lang.value,
        },
        hemi: this.$store.state.totalCritters.hemi,
      },
      critterTypeList: [
        {
          text: 'Bugs',
          value: 'bugs',
          icon: '$vuetify.bugs',
          list: [] as Critter[],
          selected: true,
        },
        {
          text: 'Fish',
          value: 'fish',
          icon: '$vuetify.fish',
          list: [] as Critter[],
          selected: true,
        },
        {
          text: 'Sea Creatures',
          value: 'sea',
          icon: '$vuetify.seaCreature',
          list: [] as Critter[],
          selected: true,
        },
      ],
      critterRarityList: [
        {
          text: 'Common',
          value: 'common',
          color: 'primary',
          selected: false,
        },
        {
          text: 'Uncommon',
          value: 'uncommon',
          color: '#72e67d',
          selected: false,
        },
        {
          text: 'Rare',
          value: 'rare',
          color: 'accent',
          selected: false,
        },
        {
          text: 'Ultra-Rare',
          value: 'ultra-rare',
          color: '#ea526f',
          selected: false,
        },
      ],
      types: ['bugs', 'fish', 'sea'],
      min: 0,
      max: 30000,
      range: [0, 30000],
      rarity: ['common', 'uncommon', 'rare', 'ultra-rare'],
      months: [
        { value: 0, text: 'January' },
        { value: 1, text: 'February' },
        { value: 2, text: 'March' },
        { value: 3, text: 'April' },
        { value: 4, text: 'May' },
        { value: 5, text: 'June' },
        { value: 6, text: 'July' },
        { value: 7, text: 'August' },
        { value: 8, text: 'September' },
        { value: 9, text: 'October' },
        { value: 10, text: 'November' },
        { value: 11, text: 'December' },
      ],
      monthsSelected: [] as number[],
    };
  },
  created() {
    this.updateSearch(this.critterSearch);
  },
  computed: {
    ...mapState({
      bugs: (state: any): Critter[] => state.totalCritters.bugs,
      fish: (state: any): Critter[] => state.totalCritters.fish,
      sea: (state: any): Critter[] => state.totalCritters.sea,
    }),
    critterTypeListFiltered(): CritterTypeObj[] {
      return this.critterTypeList.filter((obj: CritterTypeObj) => {
        if (obj.selected) {
          obj.list = [
            ...this[obj.value].map(critter => {
              if (!critter.rarity) {
                critter['show'] = 'visible';
                return critter;
              }

              const isByMonth =
                critter.availableMonths.some(month => this.monthsSelected.includes(month)) ||
                critter.allYear;
              const isByRarity = this.rarity.includes(critter.rarity.toLowerCase());
              const isByPrice = this.filterByPrice(critter.price, critter.priceCjFlick, this.range);
              const isByTime = this.filterByTime(critter.timeArray, this.timeRange);

              if (isByMonth && isByRarity && isByPrice && isByTime) {
                critter['show'] = 'visible';
              } else {
                critter['show'] = 'hide';
              }
              return critter;
            }),
          ];
        }
        return obj.selected;
      });
    },
  },
  methods: {
    ...mapMutations(['updateLang']),
    ...mapMutations('totalCritters', ['updateHemi']),
    ...mapActions('totalCritters', ['getCritterList']),
    async updateCritterList(e: string): Promise<void> {
      this.critterTypeList.forEach(async critterListObj => {
        if (e.includes(critterListObj.value)) {
          critterListObj.selected = true;
          await this.getCritterList(critterListObj.value);
          critterListObj.list = this[critterListObj.value];
        } else {
          critterListObj.selected = false;
        }
      });
    },
    async updateSearch(e: { lang: { text: string; value: string }; hemi: string }): Promise<void> {
      this.critterSearch = e;
      this.updateLang(e.lang);
      this.updateHemi(e.hemi);
      this.critterTypeList.forEach(
        async (critterListObj: CritterTypeObj) => await this.getCritterList(critterListObj.value),
      );
    },
    filterByRarity(e: string[]) {
      this.rarity = e;
    },
    filterByMonth(e: number[]) {
      this.monthsSelected = e;
    },
    filterByPrice(
      critterPrice: number,
      critterPriceCjFlick: number,
      selectedPriceRange: number[],
    ): boolean {
      return (
        (critterPrice >= selectedPriceRange[0] && critterPrice <= selectedPriceRange[1]) ||
        (critterPriceCjFlick >= selectedPriceRange[0] &&
          critterPriceCjFlick <= selectedPriceRange[1])
      );
    },
    filterByTime(critterTimeArr: number[], selectedTimeRange: number[]): boolean {
      if (critterTimeArr.length === 24) {
        return true;
      }
      if (critterTimeArr[0] > critterTimeArr[critterTimeArr.length - 1]) {
        return (
          critterTimeArr[0] <= selectedTimeRange[1] ||
          critterTimeArr[critterTimeArr.length - 1] >= selectedTimeRange[0]
        );
      }
      return (
        (critterTimeArr[0] >= selectedTimeRange[0] && critterTimeArr[0] <= selectedTimeRange[1]) ||
        (critterTimeArr[critterTimeArr.length - 1] >= selectedTimeRange[0] &&
          critterTimeArr[critterTimeArr.length - 1] <= selectedTimeRange[1]) ||
        (critterTimeArr[0] <= selectedTimeRange[0] &&
          critterTimeArr[critterTimeArr.length - 1] >= selectedTimeRange[1])
      );
    },
  },
});
